import { z } from 'zod';

export enum TipoPermissao {
    Bloqueado = 0,
    Completo = 1,
    Parcial = 2,
    Limitada = 3,
}

export type UsuarioPermissao = keyof Omit<
    UsuarioTipoPermissao,
    'upp_idpk' | 'upp_empresa_idpk' | 'upp_usuario_tipo_idpk'
>;

/** Indica se o usuário possui permissão de autenticar no backend: */
enum UsuarioPermissaoSistemaAcesso {
    Todos = 0,
    PainelWeb = 1,
    SistemasIntegrados = 2,
    Gestok = 77477,
    MercurioWebApp = 514871,
    MercurioLocal = 517341123,
    SmartPOS = 7458751,
}

export const UsuarioTipoPermissaoSchema = z.object({
    upp_cadastro_cliente: z.enum(TipoPermissao),
    upp_cadastro_fornecedor: z.enum(TipoPermissao),
    upp_cadastro_produto: z.enum(TipoPermissao),
    upp_cadastro_transportadora: z.enum(TipoPermissao),
    upp_cliente_condicao_pagamento: z.enum(TipoPermissao),
    upp_cliente_forma_pagamento: z.enum(TipoPermissao),
    upp_compra_compra: z.enum(TipoPermissao),
    upp_configuracao_configuracao: z.enum(TipoPermissao),
    upp_empresa_idpk: z.number(),
    upp_estoque_estoque: z.enum(TipoPermissao),
    upp_financeiro_boleto: z.enum(TipoPermissao),
    upp_financeiro_cartao: z.enum(TipoPermissao),
    upp_financeiro_conta_pagar: z.enum(TipoPermissao),
    upp_financeiro_conta_receber: z.enum(TipoPermissao),
    upp_financeiro_estorno: z.enum(TipoPermissao),
    upp_financeiro_movimentacao: z.enum(TipoPermissao),
    upp_financeiro_pix: z.enum(TipoPermissao),
    upp_fintech_administrativo: z.enum(TipoPermissao),
    upp_fiscal_buscador_notas: z.enum(TipoPermissao),
    upp_fiscal_mdfe: z.enum(TipoPermissao),
    upp_fiscal_nfce: z.enum(TipoPermissao),
    upp_fiscal_nfe: z.enum(TipoPermissao),
    upp_fiscal_nfse: z.enum(TipoPermissao),
    upp_fiscal_regras: z.enum(TipoPermissao),
    upp_idpk: z.number(),
    upp_logistica: z.enum(TipoPermissao),
    upp_logistica_conferencia: z.enum(TipoPermissao),
    upp_logistica_separacao: z.enum(TipoPermissao),
    upp_notificacao_notificacao: z.enum(TipoPermissao),
    upp_relatorio_cadastro: z.enum(TipoPermissao),
    upp_relatorio_compra: z.enum(TipoPermissao),
    upp_relatorio_estoque: z.enum(TipoPermissao),
    upp_relatorio_financeiro: z.enum(TipoPermissao),
    upp_relatorio_fiscal: z.enum(TipoPermissao),
    upp_relatorio_venda: z.enum(TipoPermissao),
    upp_sistema_acesso: z.enum(UsuarioPermissaoSistemaAcesso),
    upp_sistema_personalizado: z.enum(TipoPermissao),
    upp_usuario_tipo_idpk: z.number(),
    upp_venda_atendimento: z.enum(TipoPermissao),
    upp_venda_comissao: z.enum(TipoPermissao),
    upp_venda_contrato: z.enum(TipoPermissao),
    upp_venda_devolucao: z.enum(TipoPermissao),
    upp_venda_romaneio: z.enum(TipoPermissao),
    upp_venda_venda: z.enum(TipoPermissao),
    upp_venda_venda_externa: z.enum(TipoPermissao),
});

export type UsuarioTipoPermissao = z.infer<typeof UsuarioTipoPermissaoSchema>;
